<div class="toolbox-add-dialog-container">
  <p class="title">New Toolbox Item</p>
  <form [formGroup]="addItemForm" class="toolbox-form" (ngSubmit)="submit()">
    <mat-form-field>
      <mat-label>Category</mat-label>
      <mat-select formControlName="category" required>
        <mat-option *ngFor="let category of categories$ | async" [value]="category">
          {{ category.name }}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field>
      <mat-label>Text</mat-label>
      <textarea
        formControlName="text"
        matInput
        matTextareaAutosize
        matAutosizeMinRows="4"
        matAutosizeMaxRows="10"
        placeholder=""></textarea>
    </mat-form-field>
    <div class="buttons">
      <button mat-flat-button color="secondary" (click)="close(false)">Cancel</button>
      <button mat-flat-button color="primary" [disabled]="!addItemForm.valid">Save</button>
    </div>
  </form>
  <arb-message class="message" [message$]="error$"></arb-message>
</div>